import React from 'react';
import Textarea from '../Textarea';
import FieldError from '../FieldError';
import FieldWrapper from '../FieldWrapper';
import Label from '../Label';

// eslint-disable-next-line
const FormikTextareaField = ({ field, type, form, label, ...other }) => {
  return (
    <FieldWrapper>
      {label && <Label>{label}</Label>}
      <Textarea
        type={type}
        hasError={(field.name in form.touched) && (field.name in form.errors)}
        {...field}
        {...other}
      />
      {form.errors[field.name] && form.touched[field.name]
        && <FieldError>{form.errors[field.name]}</FieldError>}
    </FieldWrapper>

  );
};

export default FormikTextareaField;
